// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0f75559a","703":"c0bc73db"}[chunkId] + ".chunk.js";
};